import SkipBankingButtonView from './SkipBankingButton.view';
import withLanguageContext from '../../../hoc/withLanguageContext';
import withSkipBankingSurveyState from './withSkipBankingSurveyState';

export const SkipBankingButtonWithoutState = withLanguageContext(SkipBankingButtonView);
export const SkipBankingButtonWithState = withSkipBankingSurveyState(SkipBankingButtonWithoutState);
